import Vue from 'vue'

const MyPlugin = {
    install(Vue) {
     Vue.prototype.$can = (val) => {
        const users = JSON.parse(localStorage.getItem('users'))
        if(users.role == 'user') {
           var permiision = {view_truckers:true, edit_truckers:true, view_profile:true};
        } else {
           var permiision  = {view_truckers:true, edit_truckers:true, view_prices:true, view_add_on:true , view_profile:true};
        }
   
        const abilites  = permiision;
        return abilites[val]
     }
    },
  }
  Vue.use(MyPlugin)
